import React, { FC } from 'react'
import { Spacing } from 'Pages/landings/newLandings/common/style'
import { LayoutComponent } from 'Pages/landings/newLandings/common/Layout'
import { CookieHandlingNotice } from 'Pages/landings/newLandings/common/components'
import { BlockChoiceComponent } from 'Pages/landings/newLandings/products/middlePage/BlockChoice'
import { Footer } from 'Pages/landings/newLandings/products/common/components/Footer'
import { Title, CustomBr } from './styled'

export const MiddlePage: FC = () => (
	<LayoutComponent
		title="Зарегистрируйте бизнес и откройте расчетный счет в Сбере"
		footerComponent={<Footer />}
	>
		<Spacing height="32px" heightLX="56px" />
		<Title>
			Выберите,
			<CustomBr /> что вас интересует
		</Title>
		<Spacing height="24px" heightLX="32px" />
		<BlockChoiceComponent />
		<Spacing height="80px" heightLX="104px" />
		<CookieHandlingNotice />
	</LayoutComponent>
)
